import { defineMessages } from "../../i18n";

export const startPageMessages = defineMessages({
  ko: {
    "brand.name": "반려주식",
    "brand.tagline": "내 종목이 사는 작은 농장",
    "brand.homeLabel": "반려주식 시작",
    "header.preview": "농장 미리보기",
    "preview.windowTitle": "메뉴바에서 바로 여는 오늘의 농장",
    "preview.loading": "슬라임들이 농장으로 오고 있어요…",
    "preview.loadingTitle": "메뉴바 농장을 준비하고 있어요",
    "preview.loadingDetail": "슬라임들이 곧 도착해요",
    "hero.kicker": ({ channel }: { readonly channel: string }) =>
      `MAC MENU BAR FARM · ${channel}`,
    "hero.titleLabel": "매일 만나고, 오래 키우는 나의 반려주식",
    "hero.titleLine1": "매일 만나고,",
    "hero.titleLine2": "오래 키우는",
    "hero.titleLine3": "나의 반려주식",
    "hero.introLine1": "오르면 방방 뛰고, 내리면 엉엉 울어요.",
    "hero.introLine2":
      "메뉴바를 열어 오늘의 포트폴리오를 한눈에 확인하세요.",
    "hero.actionsLabel": "반려주식 시작 방법",
    "hero.macCta": "Mac 앱으로 받기",
    "hero.macCtaDetail": ({
      architecture,
    }: {
      readonly architecture: string;
    }) => `${architecture} · 메뉴바에서 바로`,
    "hero.webCta": "웹으로 시작하기",
    "hero.webCtaDetail": "설치 없이 이 브라우저에서",
    "hero.trustLabel": "제품 특징",
    "hero.localFirst": "장부는 이 기기에 저장",
    "hero.noLogin": "로그인 없이 시작",
    "hero.farmPreviewLabel": "반려주식 농장 미리보기",
    "release.regionLabel": "Mac 앱 정보",
    "release.eyebrow": ({ channel }: { readonly channel: string }) =>
      `MAC APP ${channel}`,
    "release.format": "형식",
    "release.formatValue": "메뉴바 앱",
    "release.support": "지원",
    "release.minimumVersion": "최소 버전",
    "release.storage": "저장 방식",
    "release.storageValue": "기기 로컬 우선",
    "footer.disclaimer":
      "투자 판단을 대신하지 않는 포트폴리오 관찰 도구예요.",
    "footer.sampleCta": "샘플 농장 구경하기",
    "install.eyebrow": ({ channel }: { readonly channel: string }) =>
      `MAC APP · ${channel}`,
    "install.title": "농장을 메뉴바에 데려가세요",
    "install.closeLabel": "설치 안내 닫기",
    "install.stableBadge": "Apple 공증 완료",
    "install.previewBadge": "미공증 Preview",
    "install.stableStep1Title": "DMG를 내려받아 열기",
    "install.stableStep1Body":
      "아래 버튼으로 공식 Universal DMG를 내려받으세요.",
    "install.stableStep2Title": "Applications 폴더로 옮기기",
    "install.stableStep2Body":
      "열린 창에서 반려주식을 Applications 폴더로 끌어다 놓으세요.",
    "install.stableStep3Title": "반려주식 바로 열기",
    "install.stableStep3Body":
      "Applications에서 반려주식을 실행하면 메뉴바에 작은 슬라임이 나타나요.",
    "install.stableWarning":
      "Developer ID 서명과 Apple 공증을 완료한 공식 Stable 앱이에요. 별도의 보안 설정이나 우회 명령이 필요하지 않아요.",
    "install.step1Title": "DMG를 내려받아 열기",
    "install.step1Body":
      "열린 창에서 반려주식을 Applications 폴더로 끌어다 놓으세요.",
    "install.step2Title": "응용 프로그램에서 한 번 실행 시도",
    "install.step2Body":
      "아직 Apple 공증 전인 Preview라 macOS가 처음 실행을 막을 수 있어요.",
    "install.step3Title": "개인정보 보호 및 보안에서 열기 허용",
    "install.step3Body":
      "시스템 설정 → 개인정보 보호 및 보안 → 아래쪽 ‘그래도 열기’를 누른 뒤 다시 실행하세요. macOS 버전에 따라 버튼 문구는 조금 다를 수 있어요.",
    "install.screenshotLinkLabel": "macOS 보안 설정 화면 크게 보기",
    "install.screenshotAlt":
      "macOS 개인정보 보호 및 보안 화면의 반려주식 그래도 열기 버튼",
    "install.screenshotCaptionPrefix": "한 번 실행한 뒤 이 화면에서",
    "install.screenshotButtonName": "그래도 열기",
    "install.screenshotCaptionSuffix":
      "를 누르면 돼요. 이미지를 누르면 크게 볼 수 있어요.",
    "install.warningPrefix":
      "Gatekeeper를 전체 비활성화할 필요는 없어요. 이 앱 한 번만 허용하는 Apple의 공식 절차를 사용합니다.",
    "install.appleGuide": "Apple 안내 보기",
    "install.download": "Universal DMG 다운로드",
    "install.verifying": "DMG 최종 검증 중",
    "install.webFallback": "우선 웹으로 시작",
    "install.checksumCopied": "체크섬 복사됨",
    "install.copyChecksum": "체크섬 복사",
  },
  en: {
    "brand.name": "Tickerlings",
    "brand.tagline": "Your portfolio, brought to life.",
    "brand.homeLabel": "Tickerlings home",
    "header.preview": "Preview the farm",
    "preview.windowTitle": "Today's farm, one click from your menu bar",
    "preview.loading": "Your Tickerlings are moving into the farm…",
    "preview.loadingTitle": "Getting your menu-bar farm ready",
    "preview.loadingDetail": "The Tickerlings will be here in a moment",
    "hero.kicker": ({ channel }) =>
      `MAC MENU BAR FARM · ${channel}`,
    "hero.titleLabel":
      "Meet them daily and grow your Tickerlings for the long run",
    "hero.titleLine1": "Meet them daily,",
    "hero.titleLine2": "grow your",
    "hero.titleLine3": "Tickerlings.",
    "hero.introLine1": "They bounce on green days and bawl on red ones.",
    "hero.introLine2":
      "Open the menu bar to catch your portfolio's mood at a glance.",
    "hero.actionsLabel": "Start with Tickerlings",
    "hero.macCta": "Get the Mac app",
    "hero.macCtaDetail": ({
      architecture,
    }: {
      readonly architecture: string;
    }) => `${architecture} · Right from your menu bar`,
    "hero.webCta": "Continue on the web",
    "hero.webCtaDetail": "No install · Stays in this browser",
    "hero.trustLabel": "Product highlights",
    "hero.localFirst": "Portfolio saved on this device",
    "hero.noLogin": "No sign-in required",
    "hero.farmPreviewLabel": "Tickerlings farm preview",
    "release.regionLabel": "Mac app details",
    "release.eyebrow": ({ channel }) => `MAC APP ${channel}`,
    "release.format": "Format",
    "release.formatValue": "Menu-bar app",
    "release.support": "Build",
    "release.minimumVersion": "Requires",
    "release.storage": "Storage",
    "release.storageValue": "Local-first",
    "footer.disclaimer":
      "A playful portfolio companion, never investment advice.",
    "footer.sampleCta": "Visit the sample farm",
    "install.eyebrow": ({ channel }) => `MAC APP · ${channel}`,
    "install.title": "Bring the farm to your menu bar",
    "install.closeLabel": "Close installation guide",
    "install.stableBadge": "Apple notarized",
    "install.previewBadge": "Notarization pending",
    "install.stableStep1Title": "Download and open the DMG",
    "install.stableStep1Body":
      "Use the button below to download the official Universal DMG.",
    "install.stableStep2Title": "Move it to Applications",
    "install.stableStep2Body":
      "In the window that opens, drag Tickerlings into your Applications folder.",
    "install.stableStep3Title": "Open Tickerlings",
    "install.stableStep3Body":
      "Launch Tickerlings from Applications and a little slime will appear in your menu bar.",
    "install.stableWarning":
      "This official Stable app is Developer ID signed and Apple notarized. No security workaround or terminal command is required.",
    "install.step1Title": "Download and open the DMG",
    "install.step1Body":
      "In the window that opens, drag the app into your Applications folder.",
    "install.step2Title": "Try opening it once",
    "install.step2Body":
      "This preview is not notarized yet, so macOS may block its first launch.",
    "install.step3Title": "Allow it in Privacy & Security",
    "install.step3Body":
      "Open System Settings → Privacy & Security, choose Open Anyway, then launch the app again. The wording can vary slightly by macOS version.",
    "install.screenshotLinkLabel":
      "Open the macOS security-settings image",
    "install.screenshotAlt":
      "macOS Privacy & Security screen showing the Korean Open Anyway button",
    "install.screenshotCaptionPrefix": "After one launch attempt, choose",
    "install.screenshotButtonName": "Open Anyway",
    "install.screenshotCaptionSuffix":
      ". Select the image to see it full size.",
    "install.warningPrefix":
      "You do not need to disable Gatekeeper. Use Apple's official flow to allow this app only.",
    "install.appleGuide": "Read Apple's guide",
    "install.download": "Download Universal DMG",
    "install.verifying": "Final DMG checks in progress",
    "install.webFallback": "Use the web version for now",
    "install.checksumCopied": "Checksum copied",
    "install.copyChecksum": "Copy checksum",
  },
});

export const landingPreviewMessages = defineMessages({
  ko: {
    "brand.name": "반려주식",
    "scenario.gain": "오른 날",
    "scenario.loss": "떨어진 날",
    "scenario.partyStatus": "수익 파티",
    "scenario.stormStatus": "거센 소나기",
    "stock.sampleAsOf": "샘플 포트폴리오",
    "menubar.regionLabel": "Mac 메뉴바 체험",
    "menubar.closeFarm": "메뉴바 반려주식 농장 닫기",
    "menubar.openFarm": "메뉴바 반려주식 농장 열기",
    "window.title": "메뉴바에서 바로 여는 오늘의 농장",
    "farm.regionLabel":
      "반려주식 샘플 농장. Enter를 누르면 선택 종목, 화살표 키를 누르면 다음 종목의 보유 정보를 볼 수 있습니다.",
    "farm.canvasLabel":
      "보유 종목 슬라임이 움직이는 반려주식 샘플 농장. 슬라임을 가리키거나 누르면 시연용 보유 정보를 볼 수 있습니다.",
    "briefing.noDataTitle": "오늘 시세를 기다리고 있어요",
    "briefing.flatTitle": "오늘은 0.00%, 잠잠해요",
    "briefing.gainTitle": ({
      change,
    }: {
      readonly change: string;
    }) => `오늘은 ${change} 올랐어요`,
    "briefing.lossTitle": ({
      change,
    }: {
      readonly change: string;
    }) => `오늘은 ${change} 떨어졌어요`,
    "briefing.summary": ({
      status,
    }: {
      readonly status: string;
    }) => `농장은 ${status} 분위기예요.`,
    "footer.title": "살아 있는 메뉴바 농장",
    "footer.detail": "슬라임을 가리키거나 눌러 보유정보 보기",
    "footer.weatherLabel": "샘플 농장 날씨",
    "closed.title": "컴퓨터 안에서 쉬는 중…",
    "closed.detail": "메뉴바 아이콘을 누르면 바로 만날 수 있어요",
  },
  en: {
    "brand.name": "Tickerlings",
    "scenario.gain": "Green day",
    "scenario.loss": "Red day",
    "scenario.partyStatus": "Profit party",
    "scenario.stormStatus": "Heavy shower",
    "stock.sampleAsOf": "Sample portfolio",
    "menubar.regionLabel": "Mac menu-bar preview",
    "menubar.closeFarm": "Close the Tickerlings menu-bar farm",
    "menubar.openFarm": "Open the Tickerlings menu-bar farm",
    "window.title": "Today's farm, one click from your menu bar",
    "farm.regionLabel":
      "Tickerlings sample farm. Press Enter to inspect the selected holding, or use the arrow keys to move between holdings.",
    "farm.canvasLabel":
      "A Tickerlings sample farm where portfolio slimes roam. Point to or select a slime to preview its holding details.",
    "briefing.noDataTitle": "Waiting for today's prices",
    "briefing.flatTitle": "A quiet 0.00% day",
    "briefing.gainTitle": ({
      change,
    }: {
      readonly change: string;
    }) => `A ${change} green day`,
    "briefing.lossTitle": ({
      change,
    }: {
      readonly change: string;
    }) => `A ${change} red day`,
    "briefing.summary": ({
      status,
    }: {
      readonly status: string;
    }) => `The farm is in ${status.toLowerCase()} mode.`,
    "footer.title": "A living menu-bar farm",
    "footer.detail": "Point to or select a slime for holding details",
    "footer.weatherLabel": "Sample farm weather",
    "closed.title": "Napping inside your Mac…",
    "closed.detail": "Select the menu-bar slime whenever you want a peek",
  },
});
